import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CommonService } from "../common/common.service";
import { Country } from 'src/app/shared/country.type';

@Injectable()
export class DriftEventService {
    private driftInitialized = false;
    private Lang: any;
    public environmentData: any;
    public countryId: any;

    constructor(private router: Router, private commonService: CommonService) {}

    public init() {
        this.environmentData = this.commonService.getEnvironmentData();
        this.countryId = this.commonService.getCountryId();
        try {
            this.loadDriftScript(this.getPlaybookId());
            // this.setupLanguageChangeListener();
            this.commonService.language$.subscribe(lang => {
                this.Lang = lang;
                this.setupLanguageChangeListener();
            })
           
        } catch (ex) {
            console.error(ex);
        }
    }

    private getPlaybookId(): number {
        let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
        if (country == 'us'){
            return this.environmentData.driftPlaybook;
        } else if (country == 'norway') {
            return this.Lang == 'no-no' ? Number(this.environmentData.norwegianDriftPlaybook) 
                                      : Number(this.environmentData.norwegianEnglishDriftPlaybook);
        } else if (country == 'germany') {
            return this.Lang == 'de-de' ? Number(this.environmentData.germanDriftPlaybook) 
                                      : Number(this.environmentData.germanEnglishDriftPlaybook);
        } else if (country == 'finland') {
            return this.Lang == 'fi-fi' ? Number(this.environmentData.finlandDriftPlaybook) 
                                      : Number(this.environmentData.finlandEnglishDriftPlaybook);
        } else if (country == 'denmark') {
            return this.Lang == 'da-dk' ? Number(this.environmentData.denmarkDriftPlaybook) 
                                      : Number(this.environmentData.denmarkEnglishDriftPlaybook);
        } else {
            return this.Lang == 'sv-se' ? Number(this.environmentData.swedishDriftPlaybook) 
                                         : Number(this.environmentData.swedishEnglishDriftPlaybook);
        }
    }
    

    private loadDriftScript(playbookId: number) {
        this.resetDrift();
        console.log(playbookId,"playbook id");
        const userPayload = JSON.stringify(this.getUserPayload());
        const script2 = document.createElement('script');
        const timestamp = new Date().getTime(); 
        script2.innerHTML = `
            var isOpen = false;
            var playbookId = ${playbookId};
            var userPayload = ${userPayload};
             /* 
            * Description - Function to load drift account with email id authentication
            */

            function DriftBot() {
                if (isOpen === false) {
                    var t = window.drift = window.drift = window.drift || [];
                    if (!t.init) {
                        if (t.invoked) {
                            isOpen = true;
                            return void (window.console && console.error && console.error("Drift snippet included twice."));
                        }
                        t.invoked = !0, t.methods = ["identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on"],
                        t.factory = function (e) {
                            return function () {
                                var n = Array.prototype.slice.call(arguments);
                                return n.unshift(e), t.push(n), t;
                            };
                        }, t.methods.forEach(function (e) {
                            t[e] = t.factory(e);
                        }), t.load = function (t) {
                            var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
                            o.type = "text/javascript", o.async = "true", o.defer = "true", o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js?v=${timestamp}";
                            var i = document.getElementsByTagName("script")[0];
                            i.parentNode.insertBefore(o, i);
                        };
                    }
                    drift.SNIPPET_VERSION = '0.3.1';
                    if (JSON.parse(localStorage['licensedUser']) === "true") {
                        var userData = JSON.parse(localStorage['${this.countryId}' +'_user']);
                        if (userData) {
                            drift.identify(userData["emailID"], {
                                email: "emailID" in userData ? userData["emailID"] : "",
                                first_name: "firstName" in userData ? userData["firstName"] : "",
                                last_name: "lastName" in userData ? userData["lastName"] : "",
                                employment_name: "companyName" in userData ? userData["companyName"] : "",
                                phone: "phoneNumber" in userData ? userData["phoneNumber"] : "",
                                support_case_origin: '${this.environmentData.driftCaseOrigin}',
                                total_channel_identifier: "total_channel_identifier" in userData ? userData["total_channel_identifier"] : ""
                            },
                            { userJwt: "drift_token" in userData ? userData["drift_token"] : "" });
                        }
                    }
                    drift.load('${this.environmentData.driftAccount}');
                    isOpen = true;
                     console.log("driftBot load isopen true")
                    drift.on('ready', function (api) {
                        drift.api.widget.hide();
                    });
                }
            }
                    /* 
                    * Description - Function to load playbook worklow based on reason/subreason selection
                    */
    function playBookLoad() {
    if (JSON.parse(localStorage['licensedUser']) !== "true") {
        DriftBot();
    }
   if (window.drift) {
    window.drift.on('ready', function (api) {
        if (isOpen) {
            drift.api.widget.show();
        } else {
            drift.api.widget.hide();
        }

        // Get common user details
        let sfdc_caseReason = JSON.parse(sessionStorage.getItem("sfdc_caseReason")) || "";
        let subReason = JSON.parse(sessionStorage.getItem("subReason")) || "";
        let caseType = JSON.parse(sessionStorage.getItem("caseType")) || "";
        let country_id = sessionStorage.getItem('country_id') || "";
        let country = sessionStorage.getItem('country') || "";
        let support_language = sessionStorage.getItem('selectedLanguage') || "";
        let productInterest = JSON.parse(sessionStorage.getItem('ProductInterest')) || "";
        let dykTitle = JSON.parse(sessionStorage.getItem("dykTitle")) || "";
        let caseRecordType = sessionStorage.getItem("caseRecordType") || "";

        // Get user type
        let userType = sessionStorage.getItem("userType") || "";

        let region = (sessionStorage.getItem('country') || "").toLowerCase()
        console.log(region,"region")

        // Define common payload
        let payload = {
            // 'support_case_origin': '${this.environmentData.driftCaseOrigin}',
            // 'country': country,
            // 'support_language': support_language
        };

        // Apply region-specific
        switch (region) {
            case "sweden":
                payload['Case Reason'] = sfdc_caseReason ? sfdc_caseReason : "";
                payload['Sub Reason'] = subReason ? subReason : "";
                payload['Case type'] = caseType ? caseType : "";
                payload['country_id'] =  country_id ? country_id.toLowerCase() : "";
                payload['Solution_Interest'] = productInterest ? productInterest : "";
                payload['dykTitle'] = dykTitle ? dykTitle : "";
                payload['Case Record Type'] = caseRecordType ? caseRecordType : "";
                payload['support_case_origin'] = '${this.environmentData.driftCaseOrigin}',
                payload['country'] = country ? country : "",
                payload['support_language'] = support_language ? support_language.split("-")[0] : ""
                break;
            case "norway":
                payload['reason'] = JSON.parse(sessionStorage.getItem("firstDropOption") || "null") || "";
                payload['subreason'] = JSON.parse(sessionStorage.getItem("secondDropOption") || "null") || "";
                payload['subreason_1'] = JSON.parse(sessionStorage.getItem("thirdDropOption") || "null") || "";
                payload['country_id'] =  country_id ? country_id.toLowerCase() : "";
                payload['country'] = country ? country : "";

                break;
            case "us":
                payload['reason'] = JSON.parse(sessionStorage.getItem("firstDropOption") || "null") || "";
                payload['subreason'] = JSON.parse(sessionStorage.getItem("secondDropOption") || "null") || "";
                payload['subreason_1'] = JSON.parse(sessionStorage.getItem("thirdDropOption") || "null") || "";
                break;
            default:
                console.log("No special region attributes applied.");
        }

        // Set user attributes in Drift
        drift.api.setUserAttributes(payload);

        // Start Drift Playbook
        drift.api.startInteraction({ interactionId: playbookId, goToConversation: true });
    });
}

}
            function playBookHide() {
                if (window.drift) {
                    window.drift.on('ready', function (api) {
                        drift.api.widget.hide();
                    });
                }
            }
             /* 
                    * Description - Function to remove drift user details when user logout
                    */
            function logoutDrift() {
                if (window.drift) {
                    playBookHide();
                    drift.reset();
                }
            }
        `;
        document.head.appendChild(script2);
        this.driftInitialized = true;
        console.log('Drift script loaded with playbook ID:', playbookId);
    }

    private setupLanguageChangeListener(): void {
        this.commonService.language$.subscribe(lang => {

        setTimeout(() => {
            if (this.commonService.getLanguage() === lang) {
                this.reinitializeDrift();
            }
        }, 100);
    })
    }

    private getUserPayload(): any {
        const country = (sessionStorage.getItem('country') || "").toLowerCase(); // Normalize to lowercase
        const support_language = this.commonService.getLanguage() || "";
        
        let payload: any = {
            'support_case_origin': this.environmentData.driftCaseOrigin,
            'country': country,
            'support_language': support_language.split("-")[0]
        };
    
        switch (country) {
            case "norway":
                // payload['reason'] = JSON.parse(sessionStorage.getItem("firstDropOption") || "null") || "";
                // payload['subreason'] = JSON.parse(sessionStorage.getItem("secondDropOption") || "null") || "";
                // payload['subreason_1'] = JSON.parse(sessionStorage.getItem("thirdDropOption") || "null") || "";
                break;
    
            case "sweden":
                payload['Case Reason'] = JSON.parse(sessionStorage.getItem("sfdc_caseReason") || "null") || "";
                payload['Sub Reason'] = JSON.parse(sessionStorage.getItem("subReason") || "null") || "";
                payload['Case type'] = JSON.parse(sessionStorage.getItem("caseType") || "null") || "";
                payload['country_id'] = localStorage.getItem('country_id')?.toLowerCase() || "";
                payload['Solution_Interest'] = JSON.parse(sessionStorage.getItem('ProductInterest') || "null") || "";
                payload['dykTitle'] = JSON.parse(sessionStorage.getItem("dykTitle") || "null") || "";
                payload['Case Record Type'] = sessionStorage.getItem("caseRecordType") || "";
                break;
    
            case "us":
                payload['reason'] = JSON.parse(sessionStorage.getItem("firstDropOption") || "null") || "";
                payload['subreason'] = JSON.parse(sessionStorage.getItem("secondDropOption") || "null") || "";
                payload['subreason_1'] = JSON.parse(sessionStorage.getItem("thirdDropOption") || "null") || "";
                break;
    
            default:
                console.warn("Unknown country detected:", country);
                break;
        }
    
        console.log("Generated user payload:", payload); // Debugging log
        return payload;
    }
    

    public reinitializeDrift() {
        console.log(this.Lang, "drift reinit");
        const playbookId = this.getPlaybookId();
        this.loadDriftScript(playbookId);
    }

    private resetDrift() {
        const driftScript = document.querySelector('script[src*="driftt.com"]');
        if (driftScript) {
            driftScript.remove();
        }
        
        if (window.drift && window.drift.reset) {
            window.drift.reset();
            console.log('Drift has been reset.');
        }
    
        this.driftInitialized = false;  
    }
}
